import _get from "lodash/get";
import _find from "lodash/find";
import { factorySelectors, FACTORY_CONSTANTS } from '@nerdwallet/nwjs-factory-redux';
import { isBlocked as isTUBlocked, isActive as isTUActive } from "./profiles";
import { DEBT_ACTIVATION_STATES, DTI_THRESHOLD } from "../constants";
export var getDebtProfileActivationState = function getDebtProfileActivationState(state) {
  var debtSummary = factorySelectors.getFact(state, FACTORY_CONSTANTS.FACT_KEYS.DEBT_SUMMARY);
  if (!debtSummary) return DEBT_ACTIVATION_STATES.UNKNOWN;
  var totalDebtAmount = debtSummary.total_debt_amount,
      annualGrossIncome = debtSummary.annual_gross_income,
      hasCompletedOnboarding = debtSummary.has_completed_onboarding,
      debtTypeSummaries = debtSummary.debt_type_summaries;
  var identity = state.identity;

  if (isTUBlocked(identity)) {
    // If blocked by TU, treat the user as blocked (even if they haven't gone through the
    // Debt activation flow)
    return DEBT_ACTIVATION_STATES.BLOCKED_TU;
  }

  if (!hasCompletedOnboarding || !isTUActive(identity)) {
    return DEBT_ACTIVATION_STATES.UNACTIVATED;
  }

  if (!_find(debtTypeSummaries, function (summary) {
    return _get(summary, 'debt_tradelines.length') > 0;
  })) {
    return DEBT_ACTIVATION_STATES.BLOCKED_NO_DEBT_TRADELINES;
  }

  if (totalDebtAmount / annualGrossIncome >= DTI_THRESHOLD) {
    return DEBT_ACTIVATION_STATES.BLOCKED_DTI;
  }

  return DEBT_ACTIVATION_STATES.ACTIVATED;
};